import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Loading } from '../components/Loading';
import ErrorMessageBox from '../components/ErrorMessageBox';
// import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { fetchReadingTest, storeReadingTest, clearTest, popAnswer } from './ducks/readingTest';
import { createFetchErrorMessage } from 'utils/api/ApiClient';
import { toast } from 'react-toastify';
import { ReadingTestQuestion } from './ReadingTestQuestion';


const ReadingTest = ()=>{
    const { type, school } = useParams();
    const test = useSelector(state => state.readingTest);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    
    /// 엌.. .두통아 다음에 하자;;
    useEffect(() => {
        dispatch( fetchReadingTest(type) );
        return () => {
            dispatch( clearTest() );
        };
    }, [dispatch, type]);

    useEffect(() => {
        // 기본, 심화진단시 완료, 종합 진단이면서 2단계가 완료됨 :저장 조건 충족
        if(!test.complete) return;

        let tmpData = {type, answers1:test.answers1, answers2:test.answers2};
        const result = dispatch( storeReadingTest( tmpData ) );
        result.then(res=>{
            //완료되면
            // 페이지를 이동해서 결과를 보여주자 아니면 여기서 보여주나?
            navigate({ pathname: `/${school}/reading/test/${res.data.id}/result`, search: ''});
        }).catch(err=>{
            const errorData = createFetchErrorMessage(err);
            toast.error(errorData.message);
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [test.complete]);
    
    const onPopAnswer = useCallback(()=>{
        dispatch( popAnswer() );
    }, [dispatch]);

    

    // 세부단계 번호
    let sectionIndex = 0;
    if( (test.type==='TEST3' && test.testIndex===0) || test.type==='TEST1' ){
        if(test.questionIndex>=22){
            sectionIndex = 2;
        }else if(test.questionIndex>=10){
            sectionIndex = 1;
        }
    }else{
        sectionIndex = Math.floor(test.questionIndex/ 5 );
    }

        
        
    
    // 로딩
    if( test.loading) return <Loading />;
    //로딩 결과
    if ( null!==test.message) return <ErrorMessageBox  message={test.message} showControls={false} />;

    if( null===test.testList[test.testIndex].questions || test.testList[test.testIndex].questions.length<=0){
        return <ErrorMessageBox message="질문을 가져오는데 실패했습니다." showControls={true} />;
    }
    
    return (
        <div className="subpage">
        <div id="contents" className={`list_page reading_test ${test.testIndex===0?'type1':'type2'}`}>
            <div className="inner">
                
            <div className="section">
                <div className="step_area">
                    <div className="type_wrap">
                        { (test.type==='TEST1' || test.type==='TEST3') && <div className={`type ${(test.testIndex===0)?'active':''}`} >기본진단</div> }
                        { (test.type==='TEST2' || test.type==='TEST3') && <div className={`type ${( test.type==='TEST2' || (test.type==='TEST3' &&test.testIndex===1) )?'active':''}`} >심화진단</div> }
                    </div>
                    
                    
                    { ( (test.type==='TEST1' || test.type==='TEST3') && test.testIndex===0 ) &&
                        <div className="step_wrap">
                            <div className={`step ${sectionIndex===0?'active':''}`}><span className="num">1</span><span className="name">독서 태도</span></div>
							<div className={`step ${sectionIndex===1?'active':''}`}><span className="num">2</span><span className="name">독서 흥미</span></div>
							<div className={`step ${sectionIndex===2?'active':''}`}><span className="num">3</span><span className="name">독서 성취도</span></div>
                        </div>
                    }

                    { ( test.type==='TEST2' || (test.type==='TEST3' && test.testIndex===1) ) &&
                        <div className="step_wrap">
                            <div className={`step ${sectionIndex===0?'active':''}`}><span className="num">1</span><span className="name">어휘력, 내용이해력</span></div>
							<div className={`step ${sectionIndex===1?'active':''}`}><span className="num">2</span><span className="name">추론 능력, 판단력, 분석력</span></div>
							<div className={`step ${sectionIndex===2?'active':''}`}><span className="num">3</span><span className="name">창의력, 문제해결력</span></div>
                        </div>
                    }
                </div>
            </div>
                <div className="section pdT0">
                    <ReadingTestQuestion test={test} type={test.type} testIndex={test.testIndex}  answers1={test.answers1} answers2={test.answers2} />
                    
                    <div className="controls">
                        { null!==test.message &&  <div className="font-italic text-danger">{test.message}</div> }
                        <button type="button" className="btn _sm _border" onClick={onPopAnswer} disabled={ test.testIndex===0 && test.questionIndex===0}><i className="icon fas fa-chevron-left"></i> 이전</button>
                    </div>
                </div>
            </div>
        </div>
        </div>
    );
}// ReadingTest
export default ReadingTest;



